import React from "react";
import { useParams } from "react-router-dom";
import Page from "../components/Page";
import {
  Alert,
  AlertTitle,
  Divider,
  LinearProgress,
  Paper,
} from "@mui/material";
import { setupLivePreviewClient } from "../utilities/livePreview";
import { useAuth } from "../auth/auth";
import { Ago } from "../utilities/time";
import KahaniModule from "@kahani/kahani-module";
import "./LivePreview.css";

const LivePreview = () => {
  // Get collection ID from url
  const { collectionID } = useParams();

  const auth = useAuth();

  // Parse search query
  const searchParams = new URLSearchParams(window.location.search);
  // const token = searchParams.get("token");
  const collectionURL = searchParams.get("collectionURL");

  const [showModule, setShowModule] = React.useState(true);

  const [previewLastUpdated, setPreviewLastUpdated] = React.useState(
    new Date()
  );
  const updatedCallback = (data) => {
    console.log("Live preview update triggered");
    console.log(data);

    setPreviewLastUpdated(new Date());

    // Hide the module for 500ms then show it again
    setTimeout(() => {
      setShowModule(false);
    }, 500);
    setTimeout(() => {
      setShowModule(true);
    }, 1000);
  };

  // Ensure we do this only once
  React.useEffect(() => {
    console.log("Listening for live preview updates");
    setupLivePreviewClient(collectionID, updatedCallback);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page title="Live Preview">
      <Paper
        sx={{
          p: 2,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Page.Title>Live Preview</Page.Title>
        {showModule && <KahaniModule storyUrl={collectionURL} />}
        {!showModule && (
          <Alert
            severity="info"
            style={{
              marginTop: "1rem",
              marginBottom: "1rem",
              width: "100%",
              maxWidth: "400px",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <AlertTitle>
              Updating content
              <LinearProgress />
            </AlertTitle>
            Please wait one moment...
          </Alert>
        )}
        <Divider />
        {auth.isAuthenticated && (
          <Alert severity="info">
            <AlertTitle>Note</AlertTitle>Share this link with anyone and they
            will be able to view (but not edit) this collection.
          </Alert>
        )}
        Last Updated: <Ago date={previewLastUpdated} updateEvery={5} />
      </Paper>
    </Page>
  );
};

export default LivePreview;
